import { render, staticRenderFns } from "./tags-manager-modal.vue?vue&type=template&id=2301d875&"
import script from "./tags-manager-modal.vue?vue&type=script&lang=js&"
export * from "./tags-manager-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports